// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__AbD2W","header":"styles_header__bk835","main":"styles_main__hLSG3","companyName":"styles_companyName__1bqhX","logo":"styles_logo__wBIZl"};